import houseImage from 'assets/img/agent-landing/zip-code/house.png';
import mapImage from 'assets/img/agent-landing/zip-code/map.png';
import { container } from 'assets/jss/material-dashboard-pro-react';
import React from 'react';
import { IAgentLandingZipCodeData } from 'types/agent-landing-page';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import GridContainer from 'creative-components/Grid/GridContainer';
import GridItem from 'creative-components/Grid/GridItem';

import DigitalAdContactForm from './DigitalAdContactForm';

const useStyles = makeStyles((theme) => ({
  container: {
    ...container,
    position: 'relative',
  },
  card: {
    position: 'relative',
    padding: '70px 80px !important',
    background: `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url(${mapImage})`,
    filter: 'drop-shadow(0px 4px 24px rgba(0, 0, 0, 0.25))',
    borderRadius: '8px',

    [theme.breakpoints.down('sm')]: {
      padding: '35px 40px !important',
    },
  },
  title: {
    textAlign: 'center',
    fontFamily: 'Vidaloka',
    fontSize: '42px',
    lineHeight: '50px',
    color: theme.palette.primary.main,
    marginBottom: '20px',
  },
  marketUpdateText: {
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.black.main,
    marginBottom: '30px',

    [theme.breakpoints.up('lg')]: {
      padding: '0 100px',
    },
  },
  chartImage: {
    objectFit: 'contain',
    width: '100%',
    maxWidth: '400px',
    marginBottom: '30px',
  },
  contactBox: {
    position: 'relative',
    background: `linear-gradient(rgba(107,144,127,0.75), rgba(107,144,127,0.75)), url(${houseImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundColor: '#6B907F',
    borderRadius: '30px',
    padding: '20px 20px',

    [theme.breakpoints.down('sm')]: {
      marginLeft: '-20px',
      marginRight: '-20px',
    },

    [theme.breakpoints.up('lg')]: {
      padding: '30px 60px',
    },
  },
}));

type Props = {
  agentLandingPageToken: string;
  zipCodeData: IAgentLandingZipCodeData;
};

const DigitalAdZipCodeDataDisplay = ({ agentLandingPageToken, zipCodeData }: Props) => {
  const classes = useStyles();

  return (
    <GridContainer className={classes.container}>
      <GridItem xs={12} className={classes.card}>
        <GridContainer style={{ marginBottom: '20px' }}>
          <GridItem xs={12}>
            <h3 className={classes.title}>{`Market Data for ${zipCodeData.zipCode}`}</h3>
          </GridItem>
          <GridItem xs={12}>
            <div className={classes.marketUpdateText}>{zipCodeData.marketUpdateText}</div>
          </GridItem>
          <GridItem xs={12} style={{ textAlign: 'center' }}>
            <img className={classes.chartImage} alt={`${zipCodeData.zipCode} Chart`} src={zipCodeData.chartImageUrl} />
          </GridItem>
        </GridContainer>

        <Box className={classes.contactBox}>
          <DigitalAdContactForm agentLandingPageToken={agentLandingPageToken} />
        </Box>
      </GridItem>
    </GridContainer>
  );
};

export default DigitalAdZipCodeDataDisplay;
